import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Input,
  Loader,
  Text,
  EmptyState,
  FlexiPagination,
} from "@flexisaf/flexibull2";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { deleteExamStart } from "../../../redux/exam/reducer";
import useExamsGet from "../../../hooks/exams/useExamsGet";
import { ExamsCardList } from "./examsCardList";
import ExamEditor from "../../exam/modals/examEditor";
import Theme from "../../../theme";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

const ExamsTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const {
    setCurrent,
    exams,
    loadingExams,
    refetch,
    pageOptions,
    totalElements,
    limit,
    page,
    setLimit,
    setPage,
    setSearchText,
  } = useExamsGet({
    examGroupId: id,
  });
  const [deleteExamGroupModal, setDeleteExamGroupModal] = useState({
    openModal: false,
    data: null,
  });

  const list = exams?.items;

  const onEdit = (data) => {
    setModal({
      show: true,
      data,
    });
  };

  const onDelete = (data) => {
    let payload = {
      id: data.id,
      callback: () => {
        refetch();
      },
    };
    dispatch(deleteExamStart(payload));
  };

  return (
    <Box>
      <Grid default="max-content max-content auto max-content">
        <Input
          placeholder="Search Exam"
          onChange={(e) => setSearchText(e.target.value)}
          width="300px"
        />

        <Box />
        <Box />

        <Button
          onClick={() => {
            setModal({
              show: true,
              data: null,
            });
          }}
          alignRight
        >
          <Text>Create Exam</Text>
        </Button>
      </Grid>

      <Box margin="30px 0">
        {loadingExams ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : list?.length > 0 ? (
          <>
            <Grid default="1fr 1fr 1fr 1fr" gap="2rem">
              {list.map((exam) => (
                <ExamsCardList
                  key={exam.id}
                  handleRedirect={() => {
                    setCurrent(exam);
                    navigate(`/exams/${exam.id}`);
                  }}
                  handleEdit={() => onEdit(exam)}
                  handleDelete={() =>
                    setDeleteExamGroupModal({
                      openModal: true,
                      data: exam,
                    })
                  }
                  examData={exam}
                  examsCount="20"
                  subjectCount="44"
                />
              ))}
            </Grid>
            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <>
            <Box align="center">
              <EmptyState
                type="documents"
                title="You have not created any exam"
                info="Please create an exam to proceed"
              />
            </Box>
          </>
        )}
      </Box>

      <ExamEditor
        open={modal.show}
        data={modal.data}
        cbProps={{ refetchPaper: false, refetchPapers: true }}
        refetch = {refetch}
        closeModal={() => {
          setModal({
            show: false,
            data: null,
          });
        }}
      />
      <DeleteModal
        isOpen={deleteExamGroupModal.openModal}
        onClose={() =>
          setDeleteExamGroupModal({ openModal: false, data: null })
        }
        title="Delete Exam Group"
        description="The execution of this action will result in the removal of the exam group and all of its associated exams from the system."
        isLoading={loadingExams}
        onDelete={() => {
          onDelete(deleteExamGroupModal?.data);
          setDeleteExamGroupModal({ openModal: false, data: null });
        }}
      />
    </Box>
  );
};

export default ExamsTab;
